export type LogRequestMeta = {
  pipelineUuid: string;
  stepUuid: string;
  range: {
    rangeStart: number;
    rangeEnd: number;
  };
  index?: number;
  requestCounter?: number;
  incrementalRequestEnabled?: boolean;
  requestType?: LogRequestType;
  isSagaLinkifyDisabled?: boolean;
};

export type StepLogMap = Map<number, string[][]>;

export enum LogRequestType {
  // this is to get the rest of logs for a command when it's not yet fetched but next streaming command already started
  PREV_COMMAND_LOG = 'command log',
  // current streaming request
  STREAMING = 'streaming',
  // clicks on command
  CLICK = 'command click',
  // on load to open commands automatically
  ON_LOAD = 'on load',
  // search or download
  SEARCH_DOWNLOAD = 'search & download',
}
